const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4003/api';

export const apiCall = async (endpoint, method = 'GET', data = null) => {
  const token = localStorage.getItem('authToken');

  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
    }
  };

  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  if (data) {
    options.body = JSON.stringify(data);
  }

  try {
    // Ensure clean base URL and endpoint concatenation
    let cleanBase = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
    let url = endpoint;
    if (url.startsWith('/api/')) {
      url = url.substring(4);
    }
    if (!url.startsWith('/')) {
      url = '/' + url;
    }
    const fullUrl = endpoint.startsWith('http') ? endpoint : `${cleanBase}${url}`;
    
    console.log('🔗 API Call:', fullUrl);

    const response = await fetch(fullUrl, options);

    if (response.status === 402) {
      const errorData = await response.json();
      const error = new Error('INSUFFICIENT_CREDITS');
      error.status = 402;
      error.details = errorData;
      throw error;
    }

    if (response.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.href = '/';
      throw new Error('Session expired. Please login again.');
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `API Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('❌ API Error:', error);
    throw error;
  }
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

export const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const validateToken = async (token) => {
  try {
    const url = `${API_BASE}/auth/validate`;
    console.log('🔐 Validating at:', url);
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Token validation failed');
    }

    return await response.json();
  } catch (error) {
    console.error('Token validation error:', error);
    throw error;
  }
};

export const loginWithWordPress = async (email, password) => {
  try {
    const response = await fetch('https://contentserp.in/wp-json/serpai/v1/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });

    if (!response.ok) {
      throw new Error('Login failed');
    }

    return await response.json();
  } catch (error) {
    console.error('WordPress login error:', error);
    throw error;
  }
};

export const mineComments = async (videoId) => {
  return await apiCall('/api/analysis/mine-comments', 'POST', { videoId });
};

